import React from 'react';
import { motion } from 'framer-motion';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiCheck, FiAlertCircle } = FiIcons;

const FormInput = ({ 
  label, 
  type = 'text', 
  value, 
  onChange, 
  placeholder, 
  error,
  success,
  icon,
  required = false,
  ...props 
}) => {
  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.3 }}
      className="mb-6"
    >
      <label className="block text-brand-primary font-semibold mb-2 text-lg">
        {label} {required && <span className="text-brand-orange">*</span>}
      </label>
      
      <div className="relative">
        {icon && (
          <div className="absolute left-4 top-1/2 transform -translate-y-1/2 text-brand-primary">
            <SafeIcon icon={icon} className="text-xl" />
          </div>
        )}
        
        <input
          type={type}
          value={value}
          onChange={onChange}
          placeholder={placeholder}
          className={`w-full p-4 ${icon ? 'pl-12' : ''} pr-12 rounded-2xl border-2 text-lg
            ${error 
              ? 'border-red-500 bg-red-50' 
              : success 
              ? 'border-green-500 bg-green-50' 
              : 'border-brand-gray bg-brand-white hover:border-brand-orange focus:border-brand-primary'
            } 
            transition-all duration-300 focus:outline-none focus:ring-4 focus:ring-brand-orange/20
            placeholder-gray-400`}
          {...props}
        />
        
        {success && (
          <div className="absolute right-4 top-1/2 transform -translate-y-1/2 text-green-500">
            <SafeIcon icon={FiCheck} className="text-xl" />
          </div>
        )}
        
        {error && (
          <div className="absolute right-4 top-1/2 transform -translate-y-1/2 text-red-500">
            <SafeIcon icon={FiAlertCircle} className="text-xl" />
          </div>
        )}
      </div>
      
      {error && (
        <motion.p
          initial={{ opacity: 0, height: 0 }}
          animate={{ opacity: 1, height: 'auto' }}
          className="text-red-500 text-sm mt-2 font-medium"
        >
          {error}
        </motion.p>
      )}
    </motion.div>
  );
};

export default FormInput;